module.exports = __webpack_public_path__ + "img/terroir-charcoal-2.d975444c.jpg";